import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    Tab,
    Tabs,
    TextField,
} from "@material-ui/core"
import { useEffect, useRef, useState } from "react"
import SecaoPassosComuns from "./SecaoPassosComuns"

const useStyles = makeStyles(() => ({
    botaoDescartar: {
        backgroundColor: "red",
        color: "white",
        "&:hover": {
            backgroundColor: "#FF4D4D",
        },
    },
    botaoSalvar: {
        backgroundColor: "#14A44D",
        color: "white",
        "&:hover": {
            backgroundColor: "#28B76C",
        },
    },
}))

export default function DialogCategorias({
    open,
    cadastrar,
    modalCategoria,
    estabelecimento,
    categorias,

    handleSalvarCategoria,
    handleCloseCategoria,
}) {
    const classes = useStyles()

    const [aba, setAba] = useState(0)
    const mostrarAbas = !cadastrar && !!modalCategoria?.id

    const id = modalCategoria ? modalCategoria?.id : null
    const versao = modalCategoria?.versao
    const nomeRef = useRef(modalCategoria?.nome)

    const proximaOrdemExib = cadastrar
        ? Math.max(0, ...(categorias?.map(c => Number(c.ordemExib) || 0) ?? [])) + 1
        : modalCategoria?.ordemExib

    const ordemExibRef = useRef(proximaOrdemExib)

    const [diaSemana, setDiaSemana] = useState(null)
    const handleChangeDiaDisponivel = e => setDiaSemana(e.target.value)
    const [turnoProduto, setTurnoProduto] = useState(null)
    const handleChangeTurnoDisponivel = e => setTurnoProduto(e.target.value)
    const [exibicaoCategoriaEnum, setExibicaoCategoriaEnum] = useState(null)
    const handleChangeExibicao = e => setExibicaoCategoriaEnum(e.target.value)
    const [modalidadePedido, setModalidadePedido] = useState(null)
    const handleChangeModalidadePedido = e => setModalidadePedido(e.target.value)
    const [ativo, setAtivo] = useState(null)
    const handleChangeAtivo = e => setAtivo(e.target.value)

    const quantidadeMinimaRef = useRef(modalCategoria?.quantidadeMinima)
    const quantidadeMaximaRef = useRef(modalCategoria?.quantidadeMaxima)

    useEffect(() => {
        setAba(0)
        if (!cadastrar) {
            setDiaSemana(modalCategoria?.diaSemana)
            setTurnoProduto(modalCategoria?.turnoProduto)
            setExibicaoCategoriaEnum(modalCategoria?.exibicaoCategoriaEnum)
            setModalidadePedido(modalCategoria?.modalidadePedido)
            setAtivo(modalCategoria?.ativo)
        } else {
            setDiaSemana(null)
            setTurnoProduto(null)
            setExibicaoCategoriaEnum(null)
            setModalidadePedido(null)
            setAtivo(true)
        }
    }, [modalCategoria])

    return (
        <>
            {open && (
                <Dialog
                    open={open}
                    onClose={handleCloseCategoria}
                    maxWidth={cadastrar ? "md" : "lg"}
                    fullWidth
                >
                    <DialogTitle>
                        {cadastrar ? "Cadastrar Categoria" : "Editar Categoria"}
                    </DialogTitle>
                    <form
                        onSubmit={e => {
                            e.preventDefault()
                            const data = {
                                id,
                                versao,

                                nome: nomeRef?.current?.value,
                                ordemExib: ordemExibRef?.current?.value,
                                diaSemana,
                                turnoProduto,
                                exibicaoCategoriaEnum,
                                modalidadePedido,
                                ativo,
                                quantidadeMinima: quantidadeMinimaRef?.current?.value,
                                quantidadeMaxima: quantidadeMaximaRef?.current?.value,
                                token: "a~I?;;+_@!AL^",
                                estabelecimento: estabelecimento,
                            }
                            handleSalvarCategoria(data)
                            handleCloseCategoria()
                        }}
                    >
                        <DialogContent>
                            {mostrarAbas && (
                                <Tabs
                                    value={aba}
                                    onChange={(_, novaAba) => setAba(novaAba)}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                    style={{ marginBottom: 16 }}
                                >
                                    <Tab label="Dados de cadastro" />
                                    <Tab label="Opções comuns a todos os produtos" />
                                </Tabs>
                            )}

                            <div hidden={mostrarAbas && aba !== 0}>
                                <Grid container spacing={1}>
                                <Grid item xs={12} sm={9} md={9}>
                                    <TextField
                                        fullWidth
                                        type="text"
                                        variant="outlined"
                                        label="Nome"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="Ex: Bebidas"
                                        inputRef={nomeRef}
                                        defaultValue={modalCategoria?.nome}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        label="Posição"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="999"
                                        inputRef={ordemExibRef}
                                        defaultValue={proximaOrdemExib}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Dia Disponível</InputLabel>
                                        <Select
                                            label="Dia Disponível"
                                            value={diaSemana}
                                            onChange={handleChangeDiaDisponivel}
                                        >
                                            <MenuItem value={null}>Todos</MenuItem>
                                            <MenuItem value={"DOMINGO"}>Domingo</MenuItem>
                                            <MenuItem value={"SEGUNDA"}>Segunda</MenuItem>
                                            <MenuItem value={"TERCA"}>Terça</MenuItem>
                                            <MenuItem value={"QUARTA"}>Quarta</MenuItem>
                                            <MenuItem value={"QUINTA"}>Quinta</MenuItem>
                                            <MenuItem value={"SEXTA"}>Sexta</MenuItem>
                                            <MenuItem value={"SABADO"}>Sabado</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Turno Disponível</InputLabel>
                                        <Select
                                            label="Turno Disponível"
                                            value={turnoProduto}
                                            onChange={handleChangeTurnoDisponivel}
                                        >
                                            <MenuItem value={null}>Todos</MenuItem>
                                            <MenuItem value={"APENAS_DIURNO"}>
                                                Apenas Diurno
                                            </MenuItem>
                                            <MenuItem value={"APENAS_NOTURNO"}>
                                                Apenas Noturno
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Exibicao Categoria</InputLabel>
                                        <Select
                                            label="Exibicao Categoria"
                                            value={exibicaoCategoriaEnum}
                                            onChange={handleChangeExibicao}
                                        >
                                            <MenuItem value={null}>Todos</MenuItem>
                                            <MenuItem value="DELIVERY">Delivery</MenuItem>
                                            <MenuItem value="PEDIDO_MESA">Pedido Mesa</MenuItem>
                                            <MenuItem value="REGISTRADOR">Registrador</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Modalidade de Pedido</InputLabel>
                                        <Select
                                            label="Modalidade de Pedido"
                                            value={modalidadePedido}
                                            onChange={handleChangeModalidadePedido}
                                        >
                                            <MenuItem value={null}>
                                                Ambos (imediato e agendamento)
                                            </MenuItem>
                                            <MenuItem value="APENAS_AGENDAMENTO">
                                                Apenas agendamento
                                            </MenuItem>
                                            <MenuItem value="APENAS_IMEDIATO">
                                                Apenas delivery imediato
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        label="Qtd Minima De Produtos"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="000"
                                        inputRef={quantidadeMinimaRef}
                                        defaultValue={modalCategoria?.quantidadeMinima}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        label="Qtd Maxima De Produtos"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="999"
                                        inputRef={quantidadeMaximaRef}
                                        defaultValue={modalCategoria?.quantidadeMaxima}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Ativo</InputLabel>
                                        <Select
                                            label="Ativo"
                                            value={ativo}
                                            onChange={handleChangeAtivo}
                                        >
                                            <MenuItem value={true}>Sim</MenuItem>
                                            <MenuItem value={false}>Não</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                </Grid>
                            </div>

                            {mostrarAbas && (
                                <div hidden={aba !== 1}>
                                    <SecaoPassosComuns categoria={modalCategoria} />
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={handleCloseCategoria}
                                className={classes.botaoDescartar}
                            >
                                Voltar
                            </Button>
                            <Button type="submit" className={classes.botaoSalvar}>
                                Salvar
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            )}
        </>
    )
}
